<template>
  <div id="top">
    <div class="menu">
      <el-row :gutter="10">
        <el-col class="logo" :span="14">
          <router-link :to="{name:home}">
            <img alt="logo" :src="$gf.sysParam($gf.lang(), 'logo')">
            <span class="dp_title">{{$gf.sysParam($gf.lang(), 'title')}}</span>
          </router-link>
        </el-col>
        <el-col class="smenu" :span="10">
          <el-button icon="el-icon-3d-data_gram" class="xsnav" type="text" @click="switchMenu"></el-button>
          <div class="menuWrapper">
            <router-link :to="{name:'indexHome'}" class="tnav_text">
              <el-button type="text" icon="el-icon-3d-home">
                <span class="dp_title">{{$t('cmsg.home')}}</span>
              </el-button>
            </router-link>
            <router-link :to="{name:'login'}" v-if="!$gf.token()" class="tnav_text">
              <el-button type="text" icon="el-icon-3d-signin">
                <span class="dp_title">{{$t('cmsg.login')}}</span>
              </el-button>
            </router-link>
          </div>
          <uMenu v-if="$gf.token()"/>
          <langSelect/>
        </el-col>
      </el-row>
    </div>
    <div class="clearfix"/>
  </div>
</template>

<script>
import langSelect from "@/views/component/lang.vue";
import uMenu from "@/views/component/user.vue";
export default {
  name: "top",
  components: {
    langSelect,
    uMenu
  },
  data() {
    return {
      home: "indexHome"
    };
  },
  methods: {
    switchMenu() {
      console.log(888);
      var el = document.querySelector(".menuWrapper");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    }
  },
  mounted() {
    if (this.$gf.token()) {
      this.home = "cases";
    }
  }
};
</script>
<style lang="scss">
#top {
  border-top: 5px solid #46a8f2;
  background-color: #ffffff;
  // height: 85px;
  .menu {
    // min-width: 1200px;
    width: 65vw;
    @media only screen and (max-width: 1020px) {
      width: 95vw;
    }
    margin: 0 auto;
    .el-row {
      margin: 0 auto;
      text-align: left;
      margin: 20px 0;
      .el-col.logo {
        // min-width: 240px;
        a {
          text-decoration: none;
          cursor: pointer;
          color: #4b91d1;
          .dp_title {
            display: inline-table;
            font-size: 28px;
            font-weight: 700;
            margin-left: 10px;
            line-height: 55px;
            vertical-align: text-bottom;
            @media only screen and (max-width: 1020px) {
              display: none;
            }
          }
          img {
            // vertical-align: text-bottom;
            height: 50px;
          }
        }
      }
      .el-col.smenu {
        text-align: right;
        .xsnav {
          display: none;
          @media only screen and (max-width: 1020px) {
            display: inline-table;
            margin-right: 10px;
          }
        }
        .menuWrapper {
          display: inline-table;
          @media only screen and (min-width: 1020px) {
            display: inline-table;
          }
          @media only screen and (max-width: 1020px) {
            position: absolute;
            top: 55px;
            right: 30px;
            display: none;
            text-align: left;
            z-index: 9999;
            background-color: #ffffff;
          }
          .tnav_text {
            color: #4b91d1;
            // margin-left: 15px;
            // border: 1px solid #4b91d1;
            // border-right: 1px solid #4b91d1;
            padding: 5px 10px;
            cursor: pointer;
            @media only screen and (max-width: 1020px) {
              display: block;
              border-bottom: 1px solid #4b91d1;
            }
            // span {
            //   .dp_title {
            //     @media only screen and (max-width: 1020px) {
            //       display: none;
            //     }
            //   }
            // }
          }
        }
      }
    }
  }
}
</style>
